export const userShardMock = {
	data: {
		search: {
			results: {
				edges: [
					{
						node: {
							description:
								'Write instead talk prove individual however strategy. So herself difference. Research authority style dark number.',
							iconUrl: 'https://picsum.photos/691/320',
							id: '5acc5def-79d4-40ac-8f52-ae46d6831c73',
							title: 'Southern reach director conference bar.',
							type: 'page',
							url: 'http://hicks.com/',
							__typename: 'SearchConfluencePageBlogAttachment',
							product: 'confluence',
							lastModified: '2006-04-04T04:18:40.945099',
							isVerified: false,
							space: {
								id: 'ab59b2b6-589b-4f2e-8d2d-170d16deb5e6',
								name: 'Cardenas, Bell and Williams',
								webUiLink: 'categories/app/categories',
							},
							socialSignal: {
								signal: 'comment',
								timestamp: '2019-08-13T21:01:17.929899',
								user: {
									accountId: '9b283ff5-4969-4b9d-a34d-bd808ee6f0ee',
									name: 'Richard Contreras',
									picture: 'https://dummyimage.com/450x361',
									email: 'angelahahn@example.org',
									extendedProfile: {
										jobTitle: 'Video editor',
									},
								},
							},
							users_viewed: [
								'd18c7954-52a1-44d1-80f3-75c2939a3c4f',
								'6acea4a7-216c-4047-b19c-d01b251b17ec',
								'e291b395-cd37-4c11-8c53-12bf086a6a4f',
								'4c4fd265-0762-4144-853c-9891aa592aec',
								'992bb120-3caf-4680-8f59-4106b3749005',
							],
							users_commented: [
								'2a41863c-9279-48f1-a808-3e2c2f98f0e1',
								'074d9b19-d8d0-4c0e-a3ce-70630a56cc43',
								'7872c24c-a7b4-48ba-9f9e-8bb4467133dd',
								'b9a4ef38-0704-4289-bdc1-d46820bb5ff1',
								'91fd1340-d1f0-4b7b-a2c9-44960ce3062e',
							],
							user_edited: [
								'd7f7b4a6-509b-42f5-a5ff-c647b4d736c9',
								'ddf897f1-c28a-4a87-9ca6-bc3ca146868b',
								'2c025aad-a99d-4a57-8a38-f21b026e1e4a',
								'0b682e46-31f3-4ec6-8ba1-c34a31cb3822',
								'9850ce5d-8fd0-4485-9dc3-9e1b04b177d6',
							],
							confluenceEntity: {
								ancestors: [
									{
										id: 'da24cfeb-7bc9-40bd-bac2-d3444e011a95',
										title: 'Building free share must role.',
										links: {
											webUi: 'wp-content/category/main',
										},
									},
									{
										id: '6c89b66c-4c22-4484-bccf-e1dd8593734e',
										title: 'Congress institution where better now stop actually.',
										links: {
											webUi: 'blog',
										},
									},
								],
								metadata: {
									titleEmojiPublished: {
										id: null,
										value: null,
									},
								},
								commentCountSummary: {
									total: 97,
								},
								likesSummary: {
									count: 27,
								},
							},
						},
					},
					{
						node: {
							description:
								'Probably upon sing short out do. Behavior increase southern long agree address risk us.',
							iconUrl: 'https://placekitten.com/986/579',
							id: '7bc0f818-ad94-4cbd-b88c-ff8b49b06610',
							title: 'Heart maintain learn despite mouth clearly seem.',
							type: 'gdoc_document',
							url: 'http://www.davis-ruiz.com/',
							__typename: 'SearchResultGoogleDocument',
							product: 'google',
							lastModified: '1995-01-15T11:05:46.063993',
							isVerified: true,
							space: {
								id: 'a09eb82a-639e-41e4-8e21-8b921c352762',
								name: 'Davis-Andrews',
								webUiLink: 'tag/app',
							},
							socialSignal: {
								signal: 'comment',
								timestamp: '1990-06-21T02:48:25.697280',
								user: {
									accountId: '848f760f-d398-41eb-ac62-eb47ec2448be',
									name: 'Sarah Foley',
									picture: 'https://dummyimage.com/683x208',
									email: 'rodney86@example.org',
									extendedProfile: {
										jobTitle: 'Energy manager',
									},
								},
							},
							users_viewed: [
								'ebda7fa5-dd22-4b2b-91fb-273727b80d4f',
								'02e50818-734e-4118-8fae-b756f41490af',
								'90f28367-962c-41fc-866b-9f2ce0e59ff7',
								'e3008455-4e68-4f03-9588-607a611c5a44',
								'7391fb8e-d99c-477e-91e2-f673c1aeec0c',
							],
							users_commented: [
								'833dc991-5548-4b89-8db6-3563bd6ad67c',
								'42ffad7c-c67b-4f8a-ba38-6623d1c77008',
								'1fa026ba-84ee-47f7-a7ad-578d816f69b5',
								'635f46fb-64ca-4932-a7df-942ef9116455',
								'ee33c5c2-4992-4506-95e1-920de4c6da3d',
							],
							user_edited: [
								'3a059892-9c26-465f-a5d9-64436247517d',
								'086f550d-2c78-46ce-b66a-3cbe2cf5dbca',
								'a51e9325-41d2-4923-8c53-905f88092c78',
								'32749082-f541-47d2-a349-318375d2d7c9',
								'5b5651ef-0e1a-496f-8e88-7bcf0960cee6',
							],
							googleDocEntity: [],
						},
					},
					{
						node: {
							description:
								'Effort modern thing college. His result couple vote act city. Material rate deep finish.\nMaybe sport upon. Somebody factor require class fund. Him he cost door organization however effect.',
							iconUrl: 'https://placekitten.com/936/487',
							id: 'b312225a-f5f7-4c6a-b41a-5a947dca56bb',
							title: 'Music bit test opportunity four.',
							type: 'page',
							url: 'http://bonilla.net/',
							__typename: 'SearchConfluencePageBlogAttachment',
							product: 'confluence',
							lastModified: '2010-05-26T18:03:36.431642',
							isVerified: false,
							space: {
								id: '44538462-d330-40d6-a9bd-d7d8b25305bd',
								name: 'Richardson-Perry',
								webUiLink: 'tag',
							},
							socialSignal: {
								signal: 'comment',
								timestamp: '1988-02-04T09:02:52.372568',
								user: {
									accountId: '3cef5fb2-d266-4fa8-b412-b8bf2100f9de',
									name: 'Andrew Bradley',
									picture: 'https://placekitten.com/930/981',
									email: 'rhondagates@example.net',
									extendedProfile: {
										jobTitle: 'Production manager',
									},
								},
							},
							users_viewed: [
								'37bd8038-2c6e-4831-bd87-489929f39956',
								'6d0609cc-7431-4ee7-87f1-f562cac0cfed',
								'bb0c92db-8435-4c7e-a595-0f7240b1b03d',
								'6cc0acbe-0862-49f6-a97b-4c6d8e3a0cbc',
								'947ff689-cbf6-4110-97d8-f1bfb6eab5d5',
							],
							users_commented: [
								'f28f50b7-9681-4c6f-abcf-0aede1e5e510',
								'e70104cf-5a38-40f8-a91c-6eacbd77a56e',
								'7d67ba23-0d34-4efe-99c2-afafd58b3e5e',
								'2c1d666d-a6fe-43bc-9cf8-7d1c41487de5',
								'bbdbb39b-a98f-4925-a7db-7c631d04d26a',
							],
							user_edited: [
								'38a2cf95-bfae-4654-9a4d-741d7f8e3400',
								'9b40e3fb-0a83-47aa-9b6a-f390862302f1',
								'51fc97fa-3409-44a1-a90b-a3883aecc345',
								'79b44666-390a-4534-ad8c-c7c01d10fb5a',
								'53df2510-6207-47bf-8b35-d1ab47245cb0',
							],
							confluenceEntity: {
								ancestors: [
									{
										id: '6a41be89-d3cc-4af7-8ec3-96a5386642f5',
										title: 'Group example second information statement.',
										links: {
											webUi: 'blog',
										},
									},
									{
										id: '68a3c9af-132c-4262-8f78-ab19841f0164',
										title: 'Personal all interest society behavior person.',
										links: {
											webUi: 'list/blog/app',
										},
									},
								],
								metadata: {
									titleEmojiPublished: {
										id: null,
										value: null,
									},
								},
								commentCountSummary: {
									total: 72,
								},
								likesSummary: {
									count: 1,
								},
							},
						},
					},
					{
						node: {
							description:
								'Member growth will if. They experience challenge enough. Brother sound realize fast.\nSong plant anything medical.',
							iconUrl: 'https://placekitten.com/151/653',
							id: '5c46b39b-a668-41d0-92df-012eac9e138f',
							title: 'Hot read painting policy environmental.',
							type: 'gdoc_document',
							url: 'https://www.brooks-osborne.com/',
							__typename: 'SearchResultGoogleDocument',
							product: 'google',
							lastModified: '2004-09-19T18:19:21.096056',
							isVerified: true,
							space: {
								id: '863891d4-e0a9-4145-82cd-53545e02bb2d',
								name: 'Johnson and Sons',
								webUiLink: 'blog',
							},
							socialSignal: {
								signal: 'comment',
								timestamp: '2008-03-03T12:49:25.101438',
								user: {
									accountId: '105d2bd6-29e3-4208-96a9-146286d6630f',
									name: 'Jason Garcia',
									picture: 'https://dummyimage.com/494x74',
									email: 'mike20@example.org',
									extendedProfile: {
										jobTitle: 'Field trials officer',
									},
								},
							},
							users_viewed: [
								'961f188b-d0fe-4f39-b5fa-a9fab3c5cc4b',
								'7ac03ca9-c40e-4abc-869f-46431b6205bb',
								'cfe88c6d-0a50-499e-a64e-de69d13fe94a',
								'38039b13-6599-406f-9bea-9570fc58ca95',
								'e1df89c4-bd94-4d67-ab26-aba538212ebb',
							],
							users_commented: [
								'1e53b7b5-acb4-4ee8-80b1-7a9d12a2ff43',
								'851f91fd-e9d8-4800-9caa-9b5a1239c65c',
								'8e0ce91a-330c-427c-ba9a-2f222498d550',
								'd7090eae-6301-402b-8c9c-a5221bbe6c2a',
								'7464f611-5d04-41b1-8a6e-394de940bc0d',
							],
							user_edited: [
								'7a1ddde1-ff48-4a28-82e2-5097a45d6aa3',
								'c06da3f2-7e4b-4105-b916-7879de52f690',
								'de43c9f6-6463-4cce-9a04-bd6188878f31',
								'8f1620f5-3bf6-480f-a62c-97a080301840',
								'accf2adb-af6c-4e4e-9dd2-d37d0843b192',
							],
							googleDocEntity: [],
						},
					},
					{
						node: {
							description:
								'Example while glass else unit. Pass play wife hundred heavy.\nFeeling see behavior southern already some work they. At bit head administration seek amount.',
							iconUrl: 'https://dummyimage.com/622x468',
							id: '46d468f8-348b-4a43-92bb-04d7fbc857b3',
							title: 'Receive window often box.',
							type: 'gdoc_document',
							url: 'http://www.dillon.com/',
							__typename: 'SearchResultGoogleDocument',
							product: 'google',
							lastModified: '2000-05-02T23:30:56.447866',
							isVerified: false,
							space: {
								id: 'c0e21975-ce5e-4edd-a0a0-8786cef6c63c',
								name: 'Green and Sons',
								webUiLink: 'tags/category',
							},
							socialSignal: {
								signal: 'comment',
								timestamp: '1978-02-16T23:04:15.102121',
								user: {
									accountId: '2f4d4944-7414-4eae-a2c5-0af0d7163de1',
									name: 'Anthony Barton',
									picture: 'https://placekitten.com/838/568',
									email: 'julia92@example.org',
									extendedProfile: {
										jobTitle: 'Oceanographer',
									},
								},
							},
							users_viewed: [
								'137661fb-56c9-4ced-af69-0be68c7068e8',
								'198815d1-6e0d-477f-99d5-e3078c03af34',
								'9aa16d7b-58b9-49e8-a28f-3792c02ecfff',
								'e718aec4-d6c2-41e5-9b46-6bffe9234474',
								'174a4d14-df8a-4274-a073-f1680daaa0eb',
							],
							users_commented: [
								'0064ca05-61c3-46f3-a335-e73f0a6ae728',
								'c70237db-90e5-40d5-b356-8718f37e669b',
								'a8076405-3c1d-4f4d-9012-e0bbedf10d8f',
								'684a7b9e-dfd2-4329-94e0-b25792a4ea7b',
								'a7e49dee-7d37-41b6-be8b-d05f60c315f8',
							],
							user_edited: [
								'e5e45afd-c7f9-4665-8969-c8c7da938b2d',
								'ec996965-4ca7-4037-9e29-ba0f45dd5e0f',
								'81751370-a21d-4751-9a5b-f9d2a0867b3e',
								'9c00622a-6f7f-4861-ac97-3358cb4e2850',
								'73543537-c543-494a-9876-4b3ecf9ff4ca',
							],
							googleDocEntity: [],
						},
					},
					{
						node: {
							description:
								'Mention break southern phone work. Network marriage hold way country church.\nHappy sea hotel serious finally next.\nIt give who.\nInstead thousand lawyer according care.',
							iconUrl: 'https://placekitten.com/350/291',
							id: '00579406-d861-4122-83a0-bbb423f95b14',
							title: 'Stay wind computer control star career range.',
							type: 'page',
							url: 'http://carter-flores.info/',
							__typename: 'SearchConfluencePageBlogAttachment',
							product: 'confluence',
							lastModified: '2016-07-17T15:51:11.675432',
							isVerified: true,
							space: {
								id: '6b128d94-ce67-4448-9be2-b52d0da5f269',
								name: 'Rodriguez-Doyle',
								webUiLink: 'wp-content',
							},
							socialSignal: {
								signal: 'comment',
								timestamp: '2015-05-01T06:23:48.066278',
								user: {
									accountId: '57d8845c-21cc-49a8-be97-3ba36068090c',
									name: 'Christopher Gonzalez',
									picture: 'https://dummyimage.com/2x1012',
									email: 'iramos@example.com',
									extendedProfile: {
										jobTitle: 'Television production assistant',
									},
								},
							},
							users_viewed: [
								'1d35dd66-6ad2-4b2f-96c6-8ba70f14cff5',
								'f87c3dba-d909-40d4-b685-68a4e9426887',
								'91182508-a548-457d-8ea4-8c9f2d3cfca0',
								'654f1539-663c-434f-bbdb-8886d78f4328',
								'51bdf189-8ab0-4904-aee0-34fb44a91dea',
							],
							users_commented: [
								'7a0302ce-7ef2-4464-bc09-042049430c40',
								'bca173b4-9567-4348-9bd5-ce873d2c8a15',
								'47b0c102-25a6-40d4-b4c7-6c39c1fde4f2',
								'67853ce0-8a04-4b4b-8271-d6db3aa3728b',
								'324539eb-7fb9-4f6d-b1da-fecfbaa2b375',
							],
							user_edited: [
								'6666e520-a652-4209-b2a8-6214d3bd10dd',
								'c0637267-2896-4833-a3a7-59906fc8b753',
								'f98e9ad2-f9a0-4c4a-9d49-064b52c9070b',
								'f3b85911-3dac-4a0d-9cff-f90b84c62ae2',
								'02304ebb-e870-4e80-8611-44869668f504',
							],
							confluenceEntity: {
								ancestors: [
									{
										id: '4a1205f3-5391-4fa1-954c-ed39f5ade15b',
										title: 'Dog young benefit improve girl.',
										links: {
											webUi: 'categories',
										},
									},
									{
										id: '5be5cb73-af2e-4c24-9a3d-d16bfe0dc928',
										title: 'Lose nor ready same develop if.',
										links: {
											webUi: 'wp-content',
										},
									},
								],
								metadata: {
									titleEmojiPublished: {
										id: null,
										value: null,
									},
								},
								commentCountSummary: {
									total: 8,
								},
								likesSummary: {
									count: 44,
								},
							},
						},
					},
				],
				queryInfo: null,
				abTest: {
					abTestId: 'no_ab_test_id',
					controlId: 'L1-OS-3recalllimitknn_L2-3pdocprod___QR-cloudberry',
					experimentId: 'L1-OS-3recalllimitknn_L2-3pdocprod___QR-cloudberry',
				},
				totalCount: 1318761,
				totalCounts: [
					{
						product: 'confluence',
						count: 1318761,
					},
				],
				pageInfo: {
					endCursor: '5388cd59-45ed-40c8-991d-b7546e1dd79e',
				},
			},
		},
	},
	extensions: {
		gateway: {
			request_id: '82bca72a-4471-4bed-ae6c-ff9ccb99b727',
			crossRegion: false,
			edgeCrossRegion: false,
		},
	},
};
